import { useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
  Theme,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ReactComponent as PartnerFusionSvg } from "assets/images/icons/partners_fusion.svg";
import {
  IdsExpandMore as IdsExpandMoreIcon,
  IdsExpandLess as IdsExpandLessIcon,
} from "components/shared/svgIcons";
import { colors } from "theme";

export const FusionPartnerCollapse = () => {
  const [expanded, setExpanded] = useState(false);

  const classes = useStyles();

  return (
    <Accordion
      square
      expanded={expanded}
      onChange={() => {}}
      className={classes.accordion}
    >
      <AccordionSummary className={classes.accordionSummary}>
        <Box display="flex" justifyContent="space-between" width={1}>
          <Box display="flex" alignItems="center" component="p" margin={0}>
            <PartnerFusionSvg width={20} height={20} />
            <Box marginLeft={1} component="span">
              <Typography variant="h6">Fusion Partner</Typography>
            </Box>
          </Box>
          <IconButton
            size="small"
            className={classes.accordionBtn}
            onClick={() => setExpanded((expanded) => !expanded)}
            aria-label="toggle"
          >
            {expanded ? <IdsExpandLessIcon /> : <IdsExpandMoreIcon />}
          </IconButton>
        </Box>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <Box mb={2}>
          <Typography variant="subtitle1" component="p">
            Fusion detection with AMP<sup>&trade;</sup> chemistry only requires
            one partner to be targeted.
          </Typography>
        </Box>
        <Typography variant="subtitle1" component="p">
          Known fusion partners are suggested when a gene query is not included
          in our predesigned, functionally-tested content.
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  accordion: {
    background: colors.periwinkle[100],
    "&.Mui-expanded": {
      margin: 0,
    },
  },
  accordionBtn: {
    margin: -8,
    "& svg": {
      fontSize: 20,
      color: theme.palette.primary.main,
    },
  },
  accordionSummary: {
    minHeight: "0 !important",
    padding: "12px 16px 16px",
    boxSizing: "border-box",
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[500]}`,
    "& > .MuiAccordionSummary-content": {
      margin: 0,
    },
  },
  accordionDetails: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2, 3, 4),
    borderTop: `1px solid ${theme.palette.grey[400]}`,
  },
}));
